import { useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { Typography, useTheme, Tooltip } from '@mui/material'
import moment from 'moment'

import ChipStatus from 'packages/ui/ChipStatus'
import Checkbox from 'packages/ui/Checkbox'

import { useSelection } from '../store'

const HeaderCheckbox = (ctx) => {
  const [selection, setSelection] = useSelection()
  return (
    <Checkbox
      checked={ctx.items.length && ctx.items.length === selection.length}
      indeterminate={Boolean(selection.length) && ctx.items.length !== selection.length}
      onChange={() => {
        if (selection.length) {
          setSelection([])
        } else {
          setSelection(ctx.items)
        }
      }}
    />
  )
}

const BodyCheckbox = ({ item }) => {
  const [selection, setSelection] = useSelection()
  const exist = useMemo(() => {
    return selection.some(({id}) => id === item.id)
  }, [item, selection])
  return (
    <Checkbox
      checked={exist}
      onChange={(e) => {
        e.stopPropagation()
        if (exist) {
          setSelection(prev => prev.filter(({ id }) => id !== item.id))
        } else {
          setSelection(prev => [...prev, item]);
        }
      }}
    />
  )
}


export const Status = ({item}) => {
  const {t } = useTranslation()
  return (
    <ChipStatus status={t(`bypass.table.status.${item.active ? 'activated' : 'deactivated'}`)}
                color={item.active ? '#587F31' : '#DC2626'}
                bgcolor={item.active ? '#E6F0D7' : '#FEE2E2'} />
  )
}

export const DeactivatedAt = ({item}) => {
  const theme = useTheme()
  const {t} = useTranslation()
  const isDeactivated = moment(item.deactivated_at).diff(moment()) < 0
  const formattedDate = item.deactivated_at ? new Date(item.deactivated_at).toLocaleDateString(i18next.language) : null
  return !item.deactivated_at
    ? <Tooltip title={t('bypass.deactivated_at.infinity')}>
        <i className={'fa-light fa-infinity'} />
      </Tooltip>
    : <Typography component={'span'} sx={{fontSize: 12, color: isDeactivated ? theme.palette.error.main : 'inherit'}}>{formattedDate}</Typography>
}

const COLUMNS_CONFIG = [
  {
    name: 'check',
    header: {
      label: HeaderCheckbox,
    },
    style: {
      width: 24,
      paddingLeft: 8,
    },
    value: item => <BodyCheckbox item={item} />,
  },
  {
    name: 'status',
    header: {
      label: ctx => ctx.t('bypass.table.status_col')
    },
    value: item => <Status item={item} />
  },
  {
    name: 'mac_address',
    header: {
      label: ctx => ctx.t('bypass.table.mac_address_col')
    },
    value: item => <Typography component={'span'} sx={{fontWeight: 500, fontSize: 12}}>{item.mac_address}</Typography>
  },
  {
    name: 'description',
    header: {
      label: ctx => ctx.t('bypass.description')
    },
    value: item => item.description,
  },
  {
    name: 'created_at',
    header: {
      label: ctx => ctx.t('bypass.table.created_at_col')
    },
    value: item => new Date(item.created_at).toLocaleDateString(i18next.language),
    sortable: true
  },
  {
    name: 'deactivated_at',
    header: {
      label: ctx => ctx.t('bypass.table.deactivated_at_col')
    },
    value: item => <DeactivatedAt item={item} />,
  }
]

export default COLUMNS_CONFIG